import { createChildListPrintContainer } from 'factories/ChildListPrint'
import Component from 'components/ProcessSetupSheet/Print/AssociatedAssets'

export default createChildListPrintContainer()(Component)
